<app-material>
    <div class="header" header>
        <h2>{{ 'lineSetter.toolRequest.pages.changeoverRequest' | translate }}</h2>
        <h5 class="subtitle">{{ 'lineSetter.toolRequest.pages.requestType' | translate }}</h5>
    </div>
    <div class="body" body>
        <app-icon-button class="left" [routerLink]="['individual']"
                         [responsive]="true"
                         variant="fa-cog"
                         text="{{'lineSetter.toolRequest.pages.buttonIndividual' | translate }}">
        </app-icon-button>
        <app-icon-button class="right"
                         [routerLink]="['group']"
                         [responsive]="true"
                         variant="fa-retweet"
                         text="{{ 'lineSetter.toolRequest.pages.buttonPartNumber' | translate }}">
        </app-icon-button>
    </div>
</app-material>

